/**
 * Copyright (c) S2 Partnership Ltd. 2021-2024
 *
 * A service that implements Network
 *
 * @summary Implements Network
 * @author S2
 *
 * Created at     : 17-05-2021
 */
import { Injectable } from '@angular/core';
import { ConnectionStatus, Network } from '@capacitor/network';
import { ReplaySubject } from 'rxjs';


@Injectable()
export class NetworkService {
  private statusChange = new ReplaySubject<ConnectionStatus>(1);
  $statusChange = this.statusChange.asObservable();

  /**
   * Standard Angular Constructor.
   *
   * @ignore
   */
  constructor() {
    // Empty constructor.
  }

  /**
   * Initalisation of network.
   */
  async onAppInit() {
    this.emitNetworkChange(await Network.getStatus());

    Network.addListener('networkStatusChange', (status) => {
      this.emitNetworkChange(status);
    });
  }

  /**
   * Event emiiter for network changes.
   *
   * @arg {NetworkStatus} status The status of the network.
   */
  private emitNetworkChange(status: ConnectionStatus) {
    this.statusChange.next(status);
  }
}
